var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.toggler = !_vm.toggler}}},[_vm._v("Ver Fachada")]),_c('FsLightbox',{attrs:{"toggler":_vm.toggler,"sources":this.imagenes,"type":"image"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }